import React from "react";
import { connect } from 'react-redux';
import { Dropdown, DropdownToggle, NavItem, NavLink } from "shards-react";

class UserActions extends React.Component {
  render() {
    const { user } = this.props
    return (
      <NavItem tag={Dropdown}>
        <DropdownToggle  tag={NavLink} className="text-nowrap pl-3 menu-user">
		      <i className="material-icons">person</i>
          <span className="d-inline-block">{  user ? user.userName : '' }</span>
        </DropdownToggle>
      </NavItem>
    );
  }
}

//=====================================
//  CONNECT
//-------------------------------------
const mapStateToProps = (state, props) => {
  return {
    user: state.session.user,
  };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserActions);
